<div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div class="field">
            <label for="nomeMae" class="font-semibold block mb-2">Nome da Mãe</label>
            <input pInputText id="nomeMae" formControlName="nomeMae" placeholder="Nome da Mãe" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
        </div>

        <div class="field">
            <label for="nomePai" class="font-semibold block mb-2">Nome do Pai</label>
            <input pInputText id="nomePai" formControlName="nomePai" placeholder="Nome do Pai" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
        </div>
    </div>
</div>
